import React from 'react';
import './App.css';
import { Outlet } from 'react-router-dom';
import ScrollToTop from './utils/scroll-to-top';

function App() {
  return (
      <div className="App">
        <ScrollToTop />
        <Outlet />
      </div>
  );
}

export default App;
